import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export type TwoFactorCodeModalData = {
  title: string;
  description: string;
  confirmButtonText: string;
};

@Component({
  selector: 'app-two-factor-code-modal',
  templateUrl: './two-factor-code-modal.component.html',
  styleUrls: ['./two-factor-code-modal.component.scss']
})
export class TwoFactorCodeModalComponent {
  form = new FormGroup({
    code: new FormControl('', [
      Validators.required,
      Validators.pattern(/^\d{6}$/)
    ])
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TwoFactorCodeModalData,
    private dialogRef: MatDialogRef<TwoFactorCodeModalComponent>
  ) {}

  normalizeCode(): void {
    const control = this.form.get('code');
    const value = String(control?.value || '')
      .replace(/\D/g, '')
      .slice(0, 6);

    control?.setValue(value, { emitEvent: false });
  }

  cancel(): void {
    this.dialogRef.close();
  }

  confirm(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.dialogRef.close(this.form.get('code')?.value);
  }
}
